import { ref, computed } from 'vue'
import { useUserStore } from '@/stores/config/userStore'

interface Rule {
  permission?: string[] // for checking isVisible
  task?: string[] // for checking isEnabled
  modified?: boolean | (() => boolean) // for checking isEnabled
  default?: boolean // default isEnabled
}

interface RuleSet {
  [target: string]: Rule
}

// interface TaskSubject {
//   subjectType: string
//   subject: any
// }

// EditorTask
export enum ET {
  Show = 'show',
  Selected = 'selected',
  NewItem = 'newItem',
  EditItem = 'editItem',
  SaveItem = 'saveItem',
  DeleteItem = 'deleteItem',
  NewCategory = 'newCategory',
  EditCategory = 'editCategory',
  SaveCategory = 'saveCategory',
  DeleteCategory = 'deleteCategory',
  NewTranslation = 'newTranslation',
  EditTranslation = 'editTranslation',
  SaveTranslation = 'saveTranslation',
  DeleteTranslation = 'deleteTranslation',
  ChangeStatus = 'changeStatus',
  Activate = 'activate',
  Active = 'active',
  Mark = 'mark',
  Copy = 'copy',
  Reset = 'reset',
  Cancel = 'cancel'
}

export function useEditorControl(customRules: RuleSet) {
  const userStore = useUserStore()

  const currentTask = ref<ET>(ET.Show)
  //const taskSubject = ref<TaskSubject | undefined>(undefined)

  //const currentTask = computed(() => cTask.value)

  const isModified = ref(false)

  function can(permission: string | string[]): boolean {
    const result = userStore.can(permission)
    return result === undefined ? false : result
  }

  //const can = (permission: string | string[]): boolean => userStore.can(permission)

  const defaultRules: RuleSet = {
    save: {
      task: [ET.NewItem, ET.EditItem, ET.NewTranslation, ET.EditTranslation],
      modified: true
    },
    activate: {
      task: [ET.EditTranslation],
      modified: false
    },
    cancel: {
      permission: ['login'],
      task: [ET.NewItem, ET.NewTranslation, ET.EditItem, ET.EditTranslation, ET.Active]
    },
    copy: {
      task: [ET.Show, ET.Selected],
      modified: false
    },
    active: {
      task: [ET.Show, ET.Selected],
      modified: false
    },
    mark: {
      task: [ET.Show, ET.Selected]
    },
    translationEdit: {
      task: [ET.Show, ET.Selected],
      modified: false
    },
    translationDelete: {
      task: [ET.Show, ET.Selected],
      modified: false
    },
    initTranslation: {
      task: [ET.Show, ET.Selected],
      modified: false
    }
  }

  const rules = computed(() => ({ ...defaultRules, ...customRules }))

  //type ButtonName = keyof typeof defaultRules

  // function isEnabled(targets: ButtonName | ButtonName[]): boolean {
  //   // If a single target is passed, convert it to an array
  //   const targetArray = Array.isArray(targets) ? targets : [targets]

  //   // Check if any of the targets are enabled
  //   return targetArray.some((target) => {
  //     const rule = rules.value[target]

  //     if (!rule) return false

  //     // Check task
  //     if (rule.task && !rule.task.includes(currentTask.value)) {
  //       return rule.default
  //     }

  //     // Check modified state for 'enabled' rules
  //     if ('modified' in rule) {
  //       if (rule.modified !== undefined && rule.modified !== isModified.value) {
  //         return rule.default
  //       }
  //     }

  //     return true
  //   })
  // }

  function isAllowed(target: string): boolean | undefined {
    const rule = rules.value[target]

    if (!rule) return false

    // Check permission
    if (!rule.permission) return false

    // Check modified state for 'enabled' rules
    const isPermitted = userStore.can(rule.permission)

    return isPermitted
  }

  // function isEnabled(rule: Rule, currentTask: string, isModified: boolean): boolean {
  //   // Check task
  //   if (rule.task && !rule.task.includes(currentTask)) {
  //     return rule.default ?? false
  //   }

  //   // Check modified state
  //   if (rule.modified !== undefined) {
  //     const modifiedValue = typeof rule.modified === 'function' ? rule.modified() : rule.modified
  //     if (modifiedValue !== isModified) {
  //       return rule.default ?? false
  //     }
  //   }

  //   return true
  // }

  function isEnabled(target: string): boolean | undefined {
    const rule = rules.value[target]

    if (!rule) return false

    // Check task
    if (rule.task && !rule.task.includes(currentTask.value)) {
      return rule.default ?? false
    }

    // Check modified state for 'enabled' rules
    if (rule.modified !== undefined) {
      if (typeof rule.modified === 'function') return rule.modified()

      if (rule.modified !== isModified.value) {
        return rule.default ?? false
      }
    }

    // if ('modified' in rule) {
    //   if (rule.modified !== undefined && rule.modified !== isModified.value) {
    //     return rule.default
    //   }
    // }
    return true
  }

  function setTask(task: ET, safeSet: boolean = true): void {
    if (task === ET.Reset) {
      reset()
    }

    // protect current editing tasks safely
    if (safeSet) {
      if ([ET.Show, ET.Selected, ET.Copy, ET.Reset].includes(currentTask.value)) {
        currentTask.value = task
      } else {
        //console.log(`setTask protected from ${currentTask.value} to ${task}`)
      }
    } else currentTask.value = task

    // taskSubject has to be intact until reset()
    // if (subject) {
    //   taskSubject.value = subject
    //   console.log('taskSubject has been set to ', subject)
    // }
  }

  function setModified(modified: boolean): void {
    isModified.value = modified
  }

  function reset(): void {
    currentTask.value = ET.Show
    isModified.value = false
    //    taskSubject.value = undefined
  }

  return {
    can,
    isAllowed,
    isEnabled,
    setTask,
    setModified,
    reset,
    currentTask,
    //    taskSubject,
    isModified
  }
}
